// extracted by mini-css-extract-plugin
module.exports = {"questions":"pricing-faq-section-module--questions--EC0rI","pricingFaq":"pricing-faq-section-module--pricingFaq--1wQyh"};